const PlanGroupIds = {
  V17_PLANGROUP_ID: 97,
  V18_PLANGROUP_ID: 98,
  START_PLANGROUP_ID: 99,
  PRO_PLANGROUP_ID: 100,
  OFFER999_PLANGROUP_ID: 102,
  NEW_FEATURE_PACKAGE_MIX: 103,
  V20_PLANGROUP_ID: 104,
  V21_PLANGROUP_ID: 105,
  V21GBB_PLANGROUP_ID: 109,
  MOBILE_FREE_PLANGROUP_ID: 159,
  LARGELISTV23_PLANGROUP_ID: 183,
  AUSTRALIA_V1: 338,
  NEW_ZEALAND_V1: 339,
  GREAT_BRITAIN_V1: 340,
  GREAT_BRITAIN_LEAD_MAGNET: 341,
  BLACKBAUD_PARTNER_GROUP_ID: 353,
  V24_6_25_LARGE_LIST: 354,
  V25_6_25: 355,
  MICRO_EMAIL_PLANGROUP_ID: 379,
};
const reactivatablePlanGroups = [
  PlanGroupIds.V17_PLANGROUP_ID,
  PlanGroupIds.V18_PLANGROUP_ID,
  PlanGroupIds.START_PLANGROUP_ID,
  PlanGroupIds.PRO_PLANGROUP_ID,
  PlanGroupIds.OFFER999_PLANGROUP_ID,
  PlanGroupIds.NEW_FEATURE_PACKAGE_MIX,
  PlanGroupIds.V20_PLANGROUP_ID,
  PlanGroupIds.V21_PLANGROUP_ID,
  PlanGroupIds.V21GBB_PLANGROUP_ID,
  PlanGroupIds.LARGELISTV23_PLANGROUP_ID,
];

const internationalPlanGroups = [
  PlanGroupIds.AUSTRALIA_V1,
  PlanGroupIds.GREAT_BRITAIN_V1,
  PlanGroupIds.NEW_ZEALAND_V1,
  PlanGroupIds.GREAT_BRITAIN_LEAD_MAGNET,
];

const PlanGroupsWithPremiumPlan = [PlanGroupIds.V21GBB_PLANGROUP_ID, PlanGroupIds.LARGELISTV23_PLANGROUP_ID];

export default PlanGroupIds;

export { PlanGroupIds, reactivatablePlanGroups, PlanGroupsWithPremiumPlan, internationalPlanGroups };
